import ArrowDown from '@/assets/icons/arrow-down.svg?react';
import { Button, IconButton } from '@/lib/Buttons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type PrevNextButtonProps = {
  type: 'previous' | 'next';
  onClick: VoidFunction;
  disabled?: boolean;
};

export const PrevNextButton: FC<PrevNextButtonProps> = ({ type, onClick, disabled }) => {
  const { t } = useTranslation('ALL');

  const isPrevious = type === 'previous';

  return (
    <>
      <IconButton
        intent='link-grey'
        text={t(type)}
        leadingIcon={isPrevious && <ArrowLeft />}
        trailingIcon={!isPrevious && <ArrowRight />}
        onClick={onClick}
        className='hidden md:flex'
        disabled={disabled}
      />
      <Button intent='secondary' onClick={onClick} className='p-2 md:hidden' disabled={disabled}>
        {isPrevious ? <ArrowLeft /> : <ArrowRight />}
      </Button>
    </>
  );
};

const ArrowLeft: FC = () => <ArrowDown className='size-5 rotate-90 text-quaternary-400' />;
const ArrowRight: FC = () => <ArrowDown className='size-5 -rotate-90 text-quaternary-400' />;
